import { z } from 'zod';

/**
 * Thin-ref на Club для «метки клуба» на событии (`EventDto.club`).
 *
 * Живёт отдельным модулем, а не в `club.ts`, намеренно: `club.ts` импортирует
 * `EventListItemDto` из `event.ts` (витрина клуба несёт список событий), поэтому
 * обратный импорт `event.ts → club.ts` замкнул бы цикл и Zod-схемы разъехались бы
 * на eval-time. `PlaceThinRefDto` живёт прямо в `place.ts` только потому, что
 * `place.ts` ничего из `event.ts` не тянет.
 *
 * Состав полей минимальный: имя для метки и `slug` для перехода на витрину.
 * Никаких `memberCount`/`joinPolicy`/членства — метка висит на PUBLIC-событии
 * клуба, которое видно всему городу, и не должна раскрывать ничего сверх того,
 * что и так отдаёт каталог.
 */
export const ClubThinRefDto = z.object({
  id: z.uuid(),
  slug: z.string(),
  name: z.string(),
});
export type ClubThinRefDto = z.infer<typeof ClubThinRefDto>;
